import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOpportunityMSNoteListData } from './mockData'
import type { IOpportunityMSNote } from '~/types/note/models'

export const {
  getNotes: getOpportunityMSNotes,
  postNote: postOpportunityMSNote,
  patchNote: patchOpportunityMSNote,
  deleteNote: deleteOpportunityMSNote,
  handlers,
} = makeNoteAPIs<IOpportunityMSNote>({
  apiPathEntityNamePrefix: 'opportunityms',
  getNoteListDataFn: getOpportunityMSNoteListData,
})
